import { ThemeButton } from './ThemeButton'
import { withThemeButton } from './withThemeButton'

const ConnectedThemeButton = withThemeButton(ThemeButton)

export { ConnectedThemeButton as ThemeButton }
